<template>
    <div>
        <el-drawer
            title="查看合作形式及报价"
            :visible.sync="look_cooperation_flag"
            @close='closeLookCooperation'
            size='50%'>
            <div class="p-color-man" v-if='base_price.length>0'>基础报价：</div>
            <div v-for='(item,index) in base_price' :key='index'>
                <div v-if='item.cps||item.cpt_20s||item.cpt_60s||item.cpt_single||item.cpt_special||item.cpa||item.cpc'>
                    <div class="mb-10">下单途径：
                        <span v-if='item.cooperation_method==1'>星图</span>
                        <span v-if='item.cooperation_method==2'>合同</span>
                        <span v-if='item.cooperation_method==3'>海南个人</span>
                    </div>
                    <div class="flex">
                    <span>合作报价：</span>
                    <div>
                        <div class="mb-10" v-if='item.cps==1'>
                            <span>CPS&nbsp; &nbsp;佣比：{{item.cps_commission}}%</span>
                        </div>
                        <div class="flex_center mb-10" v-if='item.cpt_20s==1'>
                            CPT+短视频20s&nbsp; &nbsp;{{item.cpt_20s_money}}元&nbsp; &nbsp;佣比{{item.cpt_20s_commission}}% <span v-if='item.cooperation_method!=2'>&nbsp; &nbsp;税后价{{item.cpt_20s_after_tax}}</span> &nbsp; &nbsp;返点 {{item.cpt_20s_rebate}}%&nbsp; &nbsp; <span v-if='item.cpt_20s_type==1'>CPT带货</span>
                            <span v-if='item.cpt_20s_type==2'>CPT种草</span>
                        </div>
                        <div class="flex_center mb-10" v-if='item.cpt_60s==1'>
                        CPT+短视频60s&nbsp; &nbsp;{{item.cpt_60s_money}}元&nbsp; &nbsp;佣比{{item.cpt_60s_commission}}% <span v-if='item.cooperation_method!=2'>&nbsp; &nbsp;税后价{{item.cpt_60s_after_tax}}</span> &nbsp; &nbsp;返点 {{item.cpt_60s_rebate}}%&nbsp; &nbsp; <span v-if='item.cpt_60s_type==1'>CPT带货</span>
                        <span v-if='item.cpt_60s_type==2'>CPT种草</span>
                        </div>
                        <div class="flex_center mb-10" v-if='item.cpt_single==1'>
                            CPT+直播单坑&nbsp; &nbsp;{{item.cpt_single_money}}元&nbsp; &nbsp;佣比{{item.cpt_single_commission}}% <span v-if='item.cooperation_method!=2'>&nbsp; &nbsp;税后价{{item.cpt_single_after_tax}}</span> &nbsp; &nbsp;返点 {{item.cpt_single_rebate}}%&nbsp; &nbsp;<span v-if='item.cpt_single_type==1'>CPT带货</span>
                            <span v-if='item.cpt_single_type==2'>CPT种草</span>
                        </div>
                        <div class="flex_center mb-10" v-if='item.cpt_special==1'>
                            CPT+直播专场&nbsp; &nbsp;{{item.cpt_special_money}}元&nbsp; &nbsp;佣比{{item.cpt_special_commission}}% <span v-if='item.cooperation_method!=2'>&nbsp; &nbsp;税后价{{item.cpt_special_after_tax}}</span> &nbsp; &nbsp;返点 {{item.cpt_special_rebate}}%&nbsp; &nbsp;坑位数{{item.cpt_special_place}}个&nbsp; &nbsp; <span v-if='item.cpt_special_type==1'>CPT带货</span>
                            <span v-if='item.cpt_special_type==2'>CPT种草</span>
                        </div>
                        <div class="flex_center mb-10" v-if='item.cpt_other==1'>
                            CPT+其他（图文等）&nbsp; &nbsp;{{item.cpt_other_money}}元&nbsp; &nbsp;佣比{{item.cpt_other_commission}}% <span v-if='item.cooperation_method!=2'>&nbsp; &nbsp;税后价{{item.cpt_other_after_tax}}</span> &nbsp; &nbsp;返点 {{item.cpt_other_rebate}}% &nbsp; &nbsp;<span v-if='item.cpt_other_type==1'>CPT带货</span>
                            <span v-if='item.cpt_other_type==2'>CPT种草</span>
                        </div>
                        <div class="flex_center mb-10" v-if='item.cpa==1'>
                            CPA {{item.cpa_money}}元 <span v-if='item.cooperation_method!=2'>&nbsp;&nbsp;税后价{{item.cpa_after_tax}}</span> &nbsp; &nbsp;返点 {{item.cpa_rebate}}%
                        </div>
                        <div class="flex_center mb-10" v-if='item.cpc==1'>
                            CPC {{item.cpc_money}}元 <span v-if='item.cooperation_method!=2'>&nbsp;&nbsp;税后价{{item.cpc_after_tax}}</span> &nbsp; &nbsp;返点 {{item.cpc_rebate}}%
                        </div>
                        <div class="flex_center mb-10" v-if='item.live_before>0'>
                            <div>直播前赠送预热：
                            <span v-if='item.live_before==1'>短视频</span>
                            <span v-if='item.live_before==2'>其他</span>
                            <span v-if='item.live_before==3'>无</span>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <div class="p-color-man" v-if='combination_price.length>0'>组合报价：</div>
            <div v-for='(item,index) in combination_price' :key='index+"a"'>
                <div class="mb-10">下单途径：
                    <span v-if='item.cooperation_method==1'>星图</span>
                    <span v-if='item.cooperation_method==2'>合同</span>
                    <span v-if='item.cooperation_method==3'>海南个人</span>
                </div>
                <div class="flex">
                <span>合作报价：</span>
                <div>
                    <div class="mb-10" v-if='item.cps>0'>
                        <span>CPS&nbsp; &nbsp;佣比：{{item.cps_commission}}%</span>
                    </div>
                    <div class="flex_center mb-10" v-if='item.cpt_20s>0'>
                    <span class="p-color-danger">{{item.cpt_20s}} x</span> CPT+短视频20s&nbsp; &nbsp;{{item.cpt_20s_money}}元&nbsp; &nbsp;佣比{{item.cpt_20s_commission}}% <span v-if='item.cooperation_method!=2'>&nbsp;&nbsp;税后价{{item.cpt_20s_after_tax}}</span>&nbsp; &nbsp; <span v-if='item.cpt_20s_type==1'>CPT带货</span>
                        <span v-if='item.cpt_20s_type==2'>CPT种草</span>
                    </div>
                    <div class="flex_center mb-10" v-if='item.cpt_60s>0'>
                    <span class="p-color-danger">{{item.cpt_60s}} x</span> CPT+短视频60s&nbsp; &nbsp;{{item.cpt_60s_money}}元&nbsp; &nbsp;佣比{{item.cpt_60s_commission}}% <span v-if='item.cooperation_method!=2'>&nbsp;&nbsp;税后价{{item.cpt_60s_after_tax}}</span>&nbsp; &nbsp; <span v-if='item.cpt_60s_type==1'>CPT带货</span>
                    <span v-if='item.cpt_60s_type==2'>CPT种草</span>
                    </div>
                    <div class="flex_center mb-10" v-if='item.cpt_single>0'>
                        <span class="p-color-danger">{{item.cpt_single}} x</span> CPT+直播单坑&nbsp; &nbsp;{{item.cpt_single_money}}元&nbsp; &nbsp;佣比{{item.cpt_single_commission}}% <span v-if='item.cooperation_method!=2'>&nbsp;&nbsp;税后价{{item.cpt_single_after_tax}}</span>&nbsp; &nbsp;<span v-if='item.cpt_single_type==1'>CPT带货</span>
                        <span v-if='item.cpt_single_type==2'>CPT种草</span>
                    </div>
                    <div class="flex_center mb-10" v-if='item.cpt_special>0'>
                        <span class="p-color-danger">{{item.cpt_special}} x</span> CPT+直播专场&nbsp; &nbsp;{{item.cpt_special_money}}元&nbsp; &nbsp;佣比{{item.cpt_special_commission}}% <span v-if='item.cooperation_method!=2'>&nbsp;&nbsp;税后价{{item.cpt_special_after_tax}}</span>&nbsp; &nbsp;坑位数{{item.cpt_special_place}}个&nbsp; &nbsp; <span v-if='item.cpt_special_type==1'>CPT带货</span>
                        <span v-if='item.cpt_special_type==2'>CPT种草</span>
                    </div>
                    <div class="flex_center mb-10" v-if='item.cpt_other>0'>
                        <span class="p-color-danger">{{item.cpt_other}} x</span> CPT+其他（图文等）&nbsp; &nbsp;{{item.cpt_other_money}}元&nbsp; &nbsp;佣比{{item.cpt_other_commission}}% <span v-if='item.cooperation_method!=2'>&nbsp;&nbsp;税后价{{item.cpt_other_after_tax}}</span>&nbsp; &nbsp;<span v-if='item.cpt_other_type==1'>CPT带货</span>
                        <span v-if='item.cpt_other_type==2'>CPT种草</span>
                    </div>
                    <div class="flex_center mb-10" v-if='item.cpa>0'>
                        CPA {{item.cpa_money}}元 <span v-if='item.cooperation_method!=2'>&nbsp; &nbsp;税后价{{item.cpa_after_tax}}</span>
                    </div>
                    <div class="flex_center mb-10" v-if='item.cpc>0'>
                        CPC {{item.cpc_money}}元<span v-if='item.cooperation_method!=2'>&nbsp; &nbsp;税后价{{item.cpc_after_tax}}</span>
                    </div>
                    <div class="flex_center mb-10"  v-if='item.live_before>0'>
                        <div>直播前赠送预热：
                        <span v-if='item.live_before==1'>短视频</span>
                        <span v-if='item.live_before==2'>其他</span>
                        <span v-if='item.live_before==3'>无</span>
                        </div>
                    </div>
                    <div class="mb-10">
                        <span class="p-color-danger">打包价格：</span>
                        <span class="p-color-man">{{item.combination_price}}元</span>
                        <span class="ml-10">打包后税后价：</span>
                        <span class="p-color-man">{{item.combination_after_tax}}元</span>
                        <span class="ml-10">返点：</span>
                        <span class="p-color-man">{{item.combination_rebate}}元</span>
                    </div>
                </div>
                </div>
            </div>
            <div v-if='base_price.length<=0&&combination_price.length<=0'>
                <div>达人排期：{{cpx_deal.kol_time_begin}}至{{cpx_deal.kol_time_end}}</div>
                <div class="flex">
                    <span>达人执行价格：</span>
                    <div>
                        <div v-if="cpx_deal.cpt_goods==2||cpx_deal.cpt_recommended==2">{{cpx_deal.cpt_real_price}}元 
                            <el-checkbox v-if="cpx_deal.cpt_goods==2" :checked="true" disabled>CPT带货</el-checkbox>
                            <el-checkbox v-if="cpx_deal.cpt_recommended==2" :checked="true" disabled>CPT种草</el-checkbox>
                        </div>
                        <div v-if="cpx_deal.cpc==2">{{cpx_deal.cpc_real_price}}元/点击 
                            <el-checkbox  :checked="true"  disabled>CPC</el-checkbox>
                        </div>
                            <div v-if="cpx_deal.cpa==2">{{cpx_deal.cpa_real_price}}元/点击 
                            <el-checkbox  :checked="true"  disabled>CPA</el-checkbox>
                        </div>
                            <div v-if="cpx_deal.cps==2">
                            <el-checkbox v-if="cpx_deal.cpt_goods" :checked="true"  disabled>CPS</el-checkbox>
                        </div>
                    </div>
                </div>
                <div v-if="cpx_deal.cpt_goods==2||cpx_deal.cpt_recommended==2||cpx_deal.cpc==2||cpx_deal.cpa==2">返点：<span v-if='cpx_deal.cpt_rebate'>{{cpx_deal.cpt_rebate}}%</span></div>
                <div>达人PID：{{cpx_deal.kol_pid}}</div>
                <div>备注：{{cpx_deal.price_remark}}</div>
            </div>
        </el-drawer>

    </div>
</template>
<script>
import apiUrl from "@/config/api.js";
import utils from "@/utils/util.js";
export default {
  
    name:'',
    props:{
        look_cooperation:'',
    },
    data(){
        return{
            api:{
                getKolPrice:'home/getKolPrice'
            },
            look_cooperation_flag:true,
            base_price:[],
            combination_price:[],
            cpx_deal:'',
        }
    },
    created(){
        this.getKolPrice()
    },
    methods:{
        getKolPrice(){
              this
                .$http({
                method: "GET",
                url: this.api.getKolPrice,
                params: {
                    cxdlid:this.look_cooperation.cxdlid,
                    klurid:this.look_cooperation.klurid
                }
                })
                .then(res => {
                if (res.code == 1) {
                    this.base_price=res.data.info.base_price
                    this.combination_price=res.data.info.combination_price
                    this.cpx_deal = res.data.info.cpx_deal
                } else {
                
                }
                })
                .catch(err => {
                console.log(err);
                });
        },
        closeLookCooperation(){
            this.$emit('closeLookCooperation')
        }
    }
}
</script>
<style scoped>
    .flex{
        display: flex;
    }
    .mb-10{
        margin-bottom: 10px;
    }
</style>